(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusDeleteController',TaxStatusDeleteController);

    TaxStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaxStatus'];

    function TaxStatusDeleteController($uibModalInstance, entity, TaxStatus) {
        var vm = this;
        vm.taxStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TaxStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
